export const appConfig = {
    backend_url: 'https://segpub.inteli.city/node/api/'
}